import React, { useState } from "react";
import firebase from "firebase/app";
// import { Link } from "react-router-dom";
// import { app } from "../../helpers/myFirebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import styles from "./login.module.css";

const auth = firebase.auth();

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);

  const [signInWithEmailAndPassword] = useSignInWithEmailAndPassword(auth);

  const onLogOut = () => {
    auth
      .signOut()
      .then(() => {
        console.log("You are logged out");
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  if (error) {
    return (
      <div>
        <p>Error: {error.message}</p>
      </div>
    );
  }
  if (loading) {
    return <p>Loading...</p>;
  }

  const onSubmitForm = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(email, password);
  };

  return (
    <>
      {user && (
        <div className={styles.loggedIn}>
          <p>
            Logged in for Editing as:{" "}
            <span className={styles.email}>{user.email}</span>
          </p>
          <button
            onClick={onLogOut}
            className={`funButton ${styles.logOutButt}`}
          >
            Log out
          </button>
        </div>
      )}

      {!user && (
        <>
          <h2>LOG IN:</h2>
          <form onSubmit={onSubmitForm} className={styles.loginForm}>
            <div>
              <label className={styles.inputControl}>
                <span className={styles.inputLabel}>Email: </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>

              <label className={styles.inputControl}>
                <span className={styles.inputLabel}>Password: </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
            </div>

            <input
              type="submit"
              value="Log In"
              className={`funButton ${styles.logInButt}`}
            />
          </form>
        </>
      )}
    </>
  );
}

// const PasswordReset = () => {
//   const [email, setEmail] = useState("");
//   const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
//   const [error, setError] = useState(null);
//   const onChangeHandler = (event) => {
//     const { name, value } = event.currentTarget;
//     if (name === "userEmail") {
//       setEmail(value);
//     }
//   };
//   const sendResetEmail = (event) => {
//     event.preventDefault();
//   };
//   return (
//     <div className="mt-8">
//       <h1 className="text-xl text-center font-bold mb-3">
//         Reset your Password
//       </h1>
//       <div className="border border-blue-300 mx-auto w-11/12 md:w-2/4 rounded py-8 px-4 md:px-8">
//         <form action="">
//           {emailHasBeenSent && (
//             <div className="py-3 bg-green-400 w-full text-white text-center mb-3">
//               An email has been sent to you!
//             </div>
//           )}
//           {error !== null && (
//             <div className="py-3 bg-red-600 w-full text-white text-center mb-3">
//               {error}
//             </div>
//           )}
//           <label htmlFor="userEmail" className="w-full block">
//             Email:
//           </label>
//           <input
//             type="email"
//             name="userEmail"
//             id="userEmail"
//             value={email}
//             placeholder="Input your email"
//             onChange={onChangeHandler}
//             className="mb-3 w-full px-1 py-2"
//           />
//           <button className="w-full bg-blue-400 text-white py-3">
//             Send me a reset link
//           </button>
//         </form>
//         <Link
//           to="/"
//           className="my-2 text-blue-700 hover:text-blue-800 text-center block"
//         >
//           &larr; back to sign in page
//         </Link>
//       </div>
//     </div>
//   );
// };
